var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("Title", {
            attrs: { title: "Selecione o local da limpeza para continuar" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "body" },
        [
          !_vm.preloader ? _c("NewAddress") : _vm._e(),
          _vm._v(" "),
          _vm.preloader
            ? _c("Loader")
            : !_vm.addresses || !_vm.addresses.length
              ? _c("Empty")
              : _vm._l(_vm.addresses, function(address) {
                  return _c("Address", {
                    key: address.id,
                    attrs: {
                      address: address,
                      selected: _vm.selectedAddress === address.id
                    },
                    on: {
                      addressSelected: function($event) {
                        _vm.$emit("addressSelection")
                      }
                    }
                  })
                })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("Tip", [_vm._v("Selecione, altere ou adicione um endereço")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn bg-purple",
              on: {
                click: function($event) {
                  _vm.$emit("addressSelection")
                }
              }
            },
            [_c("span", [_vm._v("Voltar")])]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5579e332", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5579e332","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/Address/Addresses.vue
// module id = null
// module chunks = 